import { format, distanceInWords, differenceInDays } from "date-fns";
import React, { useState, useEffect, useRef } from "react";
import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import PortableText from "./portableText";
import Container from "./container";
import AuthorList from "./author-list";
import { gsap, TweenMax, Expo } from "gsap";

import * as styles from "./blog-post.module.css";

function BlogPost(props) {
  const { _rawBody, authors, categories, title, mainImage, publishedAt } = props;

  const sectionRef = useRef();
  const bgRef = useRef();
  const titleRef = useRef();
  const contentRef = useRef();

  useEffect(() => {

    // TweenMax.set([contentRef.current], {
    //   opacity: 0,
    //   y: 100
    // });
    // TweenMax.to(
    //     titleRef.current, 
    //     0.45, 
    //     { 
    //         opacity: 1, 
    //         y: -25, 
    //         delay : 0.35, 
    //         onComplete : () => {
    //             TweenMax.to(
    //                 titleRef.current,
    //                 0.3,
    //                 {
    //                     y: 0,
    //                 }
    //             )
    //         }
    //     } 
    // );
    // TweenMax.to(
    //     contentRef.current, 
    //     0.45, 
    //     { 
    //         opacity: 1, 
    //         y: 0, 
    //         delay : 0.95, 
    //         onComplete : () => {
    //             $(sectionRef.current).addClass('anim-complete');
    //         }
    //     } 
    // );

    if(!$(sectionRef.current).hasClass('anim-complete')){
      let scroll_factor = 5;
      let scroll_limit = 85;

      $(window).on('scroll', () => {
          let scroll_pos = $(window).scrollTop();
          let move_by = (scroll_pos / scroll_factor);
          move_by = (move_by >= scroll_limit) ? scroll_limit : move_by;
          TweenMax.to(bgRef.current, 0.25, {
              y : 0 - move_by
          });
      });
    }
  });

  let bgImageDesktop = false;

  if(mainImage){

    bgImageDesktop = imageUrlFor(buildImageObj(mainImage))
      .width(1200)
      .height(Math.floor((9 / 16) * 1200))
      .fit("crop")
      .auto("format")
      .url();

  }

  return (
    <article className={styles.root}>
      {mainImage && mainImage.asset && (
        <div className={styles.mainImage} ref={sectionRef}>
          <h1 className={styles.bannerTitle} ref={titleRef}>{title}</h1>
          <div className={styles.bannerMask}></div>
          <div className={styles.bgWrap} ref={bgRef} style={{ backgroundImage : `url("${bgImageDesktop}")`}}>
            { 
              (bgImageDesktop) ? `<img
                src="`+imageUrlFor(buildImageObj(mainImage))
                  .width(1200)
                  .height(Math.floor((9 / 16) * 1200))
                  .fit("crop")
                  .auto("format")
                  .url()
                +`" alt="`+mainImage.alt+`"
              />` : `` 
            }
            
          </div>
        </div>
      )}
      <Container>
        <div className={styles.grid} ref={contentRef}>
          <div className={styles.mainContent}>
            <h2 className={styles.title}>{title}</h2>
            {_rawBody && <PortableText blocks={_rawBody} />}
          </div>
          <aside className={styles.metaContent}>
            {publishedAt && (
              <div className={styles.publishedAt}>
                {differenceInDays(new Date(publishedAt), new Date()) > 3
                  ? distanceInWords(new Date(publishedAt), new Date())
                  : format(new Date(publishedAt), "MMMM Do, YYYY")}
              </div>
            )}
            {authors && <AuthorList items={authors} title="Authors" />}
            {categories && (
              <div className={styles.categories}>
                <h3 className={styles.categoriesHeadline}>Categories</h3>
                <ul>
                  {categories.map(category => (
                    <li key={category._id}>{category.title}</li>
                  ))}
                </ul>
              </div>
            )}
          </aside>
        </div>
      </Container>
    </article>
  );
}

export default BlogPost;
